import {
  Alert,
  Box,
  Button,
  Dialog,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useFormik } from "formik";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Colors } from "helpers/Consts";
import { useState } from "react";
import { IResetPasswordParams } from "types/Login";
import FormikTextField from "ui/FormikTextField";
import { useMutationResetPassword } from "services/api/mutations/useMutationResetPassword";

type Props = {
  open: boolean;
  handleClose: () => void;
  handleSnackBar: () => void;
  handleMessage: (msg: string) => void;
  handleSeverity: (sev: string) => void;
};

function ResetPasswordDialog({ open, handleClose, handleSnackBar, handleMessage, handleSeverity }: Props) {
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const { mutate: resetPassword } = useMutationResetPassword();
  const formik = useFormik({
    initialValues: {
      expired: true,
      email: "",
      phone_number: "",
      enterBy: "telefone",
    } as IResetPasswordParams,
    enableReinitialize: true,
    onSubmit: async (values: IResetPasswordParams) => {
      let unMaskedTel = values.phone_number.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace("-", "")
      // console.log(unMaskedTel);
      if(values.phone_number.length > 1) {
        unMaskedTel = "+55" + unMaskedTel;
      }
      // console.log(unMaskedTel);
      let body = {
        phone_number: unMaskedTel,
        email: values.email,
        expired: true,
      }
      // console.log(body);
      await resetPassword(body)
      formik.setSubmitting(false);
      // console.log(response);
      setTimeout(() => {
        handleSnackBar();
        // if(response)
        handleMessage("Senha resetada com sucesso.")
        handleSeverity("success")
        handleClose();
        resetValues();
      }, 1000);
    },
  });
  const handleCloseSnackBar = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  function resetValues() {
    formik.values.email = "";
    formik.values.phone_number = "";
  }
  return (
    <Dialog
      onClose={() => {
        handleClose();
        resetValues();
      }}
      open={open}
    >
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {mensagem}
        </Alert>
      </Snackbar>
      <DialogTitle>
        <Box display="flex" sx={{
          alignItems: 'center'
        }}>
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              handleClose();
              resetValues();
            }}
          >
            <ArrowBackIosIcon fill={Colors.orangePrimary} />
          </IconButton>
          <Typography
            color={Colors.orangePrimary}
            fontSize="16px"
            textAlign="center"
            fontWeight={'700'}
          >
            Resetar sua senha
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Box>
            <Box display={"flex"}>
              <FormControl
                sx={{
                  display: "flex",
                  width: "100%",
                  flexGrow: 1,
                }}
              >
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="enterBy"
                  value={formik.values.enterBy}
                  onChange={formik.handleChange}
                >
                  <FormControlLabel
                    value="email"
                    control={<Radio size="small" />}
                    onChange={formik.handleChange}
                    onClick={() => {
                      formik.values.email = "";
                      formik.values.phone_number = "";
                    }}
                    label={
                      <Typography fontSize="12px" color={Colors.baseTextColor}>
                        Entrar com e-mail
                      </Typography>
                    }
                  />
                  <Box flexGrow={1} />
                  <FormControlLabel
                    value="telefone"
                    control={<Radio size="small" />}
                    onChange={formik.handleChange}
                    onClick={() => {
                      formik.values.email = "";
                      formik.values.phone_number = "";
                    }}
                    label={
                      <Typography fontSize="12px" color={Colors.baseTextColor}>
                        Entrar com telefone
                      </Typography>
                    }
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box>
              {formik.values.enterBy === "telefone" ? (
                <FormikTextField
                  id="phone_number"
                  type="text"
                  required
                  variant="standard"
                  onChange={formik.handleChange}
                  value={formik.values.phone_number}
                />
              ) : (
                <TextField
                  sx={{
                    marginTop: "10px",
                    paddingX: 1,
                    MozAnimation: "none",
                    WebkitAppearance: "none",
                    appearance: "none",
                  }}
                  fullWidth
                  id="email"
                  type={"email"}
                  placeholder={"Digite seu email"}
                  variant="standard"
                  required
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
              )}
            </Box>
          </Box>
          {/* {(formik.errors.phone_number || formik.errors.name) && (
            <Alert
              severity="warning"
              sx={{
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography fontSize="14px" fontWeight={700}>
                Erro na edição
              </Typography>
            </Alert>
          )} */}
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={
              formik.values.email === "" && formik.values.phone_number === ""
            }
            fullWidth
            sx={{ color: "white", marginTop: "15px" }}
          >
            Resetar Senha
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default ResetPasswordDialog;
